import { useMutation, useQueryClient } from '@tanstack/react-query';
import http from '../axios';
import { useQuery } from '@tanstack/react-query';

const useDeleteEpe = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationKey: 'deleteEpe',
		mutationFn: async ({ driveLogId, id }) => {
			await http.delete(`/drive-log/${driveLogId}/epe/${id}`);
		},
		onMutate: async (variables) => {
			queryClient.setQueryData(['dlEpes', variables.driveLogId], (oldData) =>
				oldData.filter((item) => item.id !== variables.id),
			);
		},
	});
};

const useAddEpe = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationKey: 'addEpe',
		mutationFn: async ({ driveLogId, values }) => {
			return http.post(`/drive-log/${driveLogId}/epe/`, values);
		},
		onMutate: async ({ driveLogId, values, action }) => {
			await queryClient.setQueryData(['dlEpes', driveLogId], (oldData) => {
				if (!oldData) return [values];
				return [...oldData, { ...values }].sort(
					(a, b) => new Date(a.hour_start) - new Date(b.hour_start),
				);
			});
			if (action) action();
		},

		
		onSettled: (_data, _error, variables) => {
			if (variables?.driveLogId) {
			  queryClient.invalidateQueries(['dlEpes', variables.driveLogId]);
			}
		  },
	});
};

const useUpdateEpe = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationKey: 'updateEpe',
		mutationFn: async ({ driveLogId, epeId, values }) => {
			return http.put(`/drive-log/${driveLogId}/epe/${epeId}`, { ...values });
		},
		onMutate: async ({ driveLogId, epeId, values, action }) => {
			const data = await queryClient.getQueryData(['dlEpes', driveLogId]);
			if (data && Array.isArray(data) && data.length > 0) {
				await queryClient.setQueryData(['dlEpes', driveLogId], () => {
					const val = data.map((item) => {
						if (item.id === epeId) {
							return { ...item, ...values };
						}
						return item;
					});
					return val;
				});
			}
			if (action) action();
		},
		onSettled: (_, variables, __) => {
			// Invalider ou mettre à jour le cache après la suppression
			queryClient.invalidateQueries(['dlEpes', variables.driveLogId]);
		},
	});
};

const useGetEpeById = (driveLogId, epeId) => {
	return useQuery(['epe', driveLogId, epeId], async () => {
		const { data } = await http.get(`/drive-log/${driveLogId}/epe/${epeId}`);
		return data;
	});
};

export const useEpeQueries = () => {
	const deleteEpe = useDeleteEpe();
	const addEpe = useAddEpe();
	const updateEpe = useUpdateEpe();
	const getEpeById = useGetEpeById;

	return { addEpe, updateEpe, deleteEpe, getEpeById  };
};
